export const MODELS_EVENT_ID = 999999;
export const getFolderTrail = (folders, folderId) => {
    const trail = [];
    const visited = new Set();
    while (folderId && !visited.has(folderId)) {
        visited.add(folderId);
        const currentId = folderId;
        const folder = folders.find(f => f.id === currentId);
        if (!folder) break;
        trail.unshift(folder);
        folderId = folder.parentId;
    }
    return trail;
};
export const getFolderPath = (folders, folderId) => getFolderTrail(folders, folderId).map(f => f.nom).join(' / ');
export const getFolderProves = (names, items, folderId) => names.filter(name => (items[name] || null) === folderId);
export const getMoveDestinations = (folders, movingId) => folders
    .filter(folder => !movingId || !getFolderTrail(folders, folder.id).some(f => f.id === movingId))
    .sort((a, b) => getFolderPath(folders, a.id).localeCompare(getFolderPath(folders, b.id), 'ca'));
